import { useReducedMotion } from 'framer-motion';
import { useAppearancePrefs } from '@/lib/appearancePrefs';

/**
 * Single source of truth for "should we suppress motion?". Combines the OS
 * `prefers-reduced-motion` (via Framer) with the in-app "Снизить анимацию"
 * setting (appearancePrefs.reducedMotion). The `reduce-motion` CSS class only
 * zeroes CSS animation/transition durations — JS-driven framer-motion effects
 * (dock magnify, elastic slider spring, BlurText, the ball pit) must consult
 * this hook to honour the toggle.
 */
export function useReduceMotion(): boolean {
  const os = useReducedMotion();
  const { reducedMotion } = useAppearancePrefs();
  return !!os || reducedMotion;
}
